import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const productHeaderDefaultVariants = {}
const productHeaderCompoundVariants = []

const productHeaderSlotNames = [
  [
    "root",
    "ProductHeader__root"
  ],
  [
    "content",
    "ProductHeader__content"
  ],
  [
    "name",
    "ProductHeader__name"
  ],
  [
    "nav",
    "ProductHeader__nav"
  ],
  [
    "addon",
    "ProductHeader__addon"
  ]
]
const productHeaderSlotFns = /* @__PURE__ */ productHeaderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, productHeaderDefaultVariants, getSlotCompoundVariant(productHeaderCompoundVariants, slotName))])

const productHeaderFn = memo((props = {}) => {
  return Object.fromEntries(productHeaderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const productHeaderVariantKeys = []
const getVariantProps = (variants) => ({ ...productHeaderDefaultVariants, ...compact(variants) })

export const productHeader = /* @__PURE__ */ Object.assign(productHeaderFn, {
  __recipe__: false,
  __name__: 'productHeader',
  raw: (props) => props,
  variantKeys: productHeaderVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, productHeaderVariantKeys)
  },
  getVariantProps
})